import { render, staticRenderFns } from "./reasonListPage.vue?vue&type=template&id=f813d094&scoped=true&"
import script from "./reasonListPage.vue?vue&type=script&lang=js&"
export * from "./reasonListPage.vue?vue&type=script&lang=js&"
import style0 from "./reasonListPage.vue?vue&type=style&index=0&id=f813d094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f813d094",
  null
  
)

export default component.exports